<template>
  <div class="cartouchePublic">
    <div style="font-size:24px" :class="window.width < 480 ? 'container-fluid' : 'container'">
      <div>
        <span
          style="cursor:pointer"
          v-if="
            parameters === 'adminPage' ||
              parameters === 'adminQuestionsPage' ||
              parameters === 'adminResultats' ||
              parameters === 'client'
          "
          @click="returnFunction()"
        >
          <img src="~@/assets/img/public_logo.png" alt="logo-sondage" />
          sondage
        </span>
        <div class="is-pulled-right" @click="searchBar()">
          <img
            v-if="parameters === 'adminPage'"
            style="cursor:pointer;width:20px;height:20px;"
            src="~@/assets/img/icons/searchbar-icon.png"
            alt="searchbar-icon"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Header',
  props: {
    parameters: String,
    window: Object
  },
  computed: {
    ...mapGetters(['adminActiveComponents'])
  },
  methods: {
    returnFunction () {
      switch (this.parameters) {
        case 'adminPage':
          this.$store.commit('ADMIN_ACTIVE_COMPONENTS', {
            cardList: true,
            parameters: false
          })
          break
        case 'adminQuestionsPage':
          this.$store.commit('ADMIN_ACTIVE_COMPONENTS', {
            cardList: true,
            parameters: false
          })
          this.$router.push({ name: 'Admin' })
          break
        case 'adminResultats':
          this.$store.commit('ADMIN_ACTIVE_COMPONENTS', {
            cardList: true,
            parameters: false
          })
          this.$router.push({ name: 'Admin' })
          break
        case 'client':
          this.$router.replace({ name: 'home' }).catch(err => {})
          break
      }
    },
    searchBar () {
      this.$store.commit('ADMIN_ACTIVE_COMPONENTS', {
        searchBar: !this.adminActiveComponents.searchBar,
        cardList: true
      })
    }
  }
}
</script>

<style scoped>
.cartouchePublic {
  background: #424a60;
  color: white;
  text-align: left;
  height: 40px;
  font-size: 24px;
  z-index: 1000;
  position: relative;
}

.cartouchePublic img {
  height: 26px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue